import { render, staticRenderFns } from "./LpuServicesPrice.vue?vue&type=template&id=5b0e7339&scoped=true&"
import script from "./LpuServicesPrice.vue?vue&type=script&lang=js&"
export * from "./LpuServicesPrice.vue?vue&type=script&lang=js&"
import style0 from "./LpuServicesPrice.vue?vue&type=style&index=0&id=5b0e7339&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e7339",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0e7339')) {
      api.createRecord('5b0e7339', component.options)
    } else {
      api.reload('5b0e7339', component.options)
    }
    module.hot.accept("./LpuServicesPrice.vue?vue&type=template&id=5b0e7339&scoped=true&", function () {
      api.rerender('5b0e7339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuServices/components/LpuServicesPrice.vue"
export default component.exports